import {
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@nutrien/cxp-components';
import React, { useEffect, useState } from 'react';

import SignatureAndStampTopBar from './SignatureAndStampTopBar';
import SignatureAndStampUpload from './SignatureAndStampUpload';

const useStyles = makeStyles(() =>
  createStyles({
    paper: {
      top: '0px',
      left: '0px',
      padding: '0px',
    },
    body: {
      padding: '0px',
      overflow: 'auto',
    },
    buttonGrid: {
      height: '70px',
      background: 'rgb(38,38,38)',
      bottom: 0,
      position: 'fixed',
      alignContent: 'space-evenly',
      '& .cancelButton': {
        width: '100px',
        marginLeft: '10px',
      },
    },
    dialogActions: {
      padding: '0px',
      '& .MuiDialogActions-root': {
        padding: '0px',
      },
      '& .saveButton': {
        fontSize: '14px',
        fontWeight: 700,
        width: '65px',
      },
    },
  }),
);

interface Props {
  id: string;
  open: boolean;
  anchorEl: HTMLButtonElement | null;
  onClose: () => void;
}

const SignatureAndStamp: React.FC<Props> = ({ id, open, anchorEl, onClose }) => {
  const classes = useStyles();
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [isUploadButDisable, setIsUploadButDisable] = useState<boolean>(true);
  const [saveSignAndStamp, setSaveSignAndStamp] = useState<boolean>(false);

  useEffect(() => {
    if (isUploadButDisable) setSaveSignAndStamp(false);
  }, [isUploadButDisable]);

  const handleKeyEvent = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' && !isUploadButDisable) {
      setIsUploadButDisable(true);
      setSaveSignAndStamp(true);
    }
  };

  return (
    <>
      <div>
        <Dialog
          open={open}
          onClose={onClose}
          fullScreen
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          onKeyUp={handleKeyEvent}
          data-testid="signDialog"
        >
          <DialogTitle id="alert-dialog-title" className={classes.paper}>
            <SignatureAndStampTopBar
              open={open}
              onClose={onClose}
              anchorEl={anchorEl}
              id={id}
              title="Signature & Stamp"
            />
          </DialogTitle>
          <DialogContent className={classes.body}>
            <SignatureAndStampUpload
              setIsChecked={setIsChecked}
              isChecked={isChecked}
              setIsUploadButDisable={setIsUploadButDisable}
              isHandleSignAndStamp={saveSignAndStamp}
              setSaveSignAndStamp={setSaveSignAndStamp}
            />
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Grid item container xs={12} className={classes.buttonGrid}>
              <Grid item container xs={1} justifyContent="center">
                <Button
                  onClick={onClose}
                  variant="outlined"
                  color="primary"
                  className="cancelButton"
                  data-testid="signAndStampCancelbutton"
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item xs={10} />
              <Grid item container xs={1} justifyContent="center">
                <Button
                  onClick={() => {
                    setIsUploadButDisable(true);
                    setSaveSignAndStamp(true);
                  }}
                  variant="contained"
                  color="primary"
                  className="saveButton"
                  disabled={isUploadButDisable}
                  data-testid="saveButton"
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default SignatureAndStamp;
